import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import useCheckoutPayment from 'hooks/useCheckoutPayment'
import { CHECKOUT_PAYMENT } from 'constants/app-paths'
import { currencyFormat } from 'utils/format'
import { CHECKOUT_CUSTOMER_PENDINGS } from 'constants/checkout-steps'

import { InfoPage } from 'templates/InfoPage'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import DescItemInfo from 'ui-components/DescItemInfo/DescItemInfo'
import { Card } from 'ui-components/Card'
import { Button } from 'ui-components/Button'

import { SideMenu } from 'components/Checkout/SideMenu'
import { Orders } from './components/Orders'
import { Debts } from './components/Debts'
import { Bottom, Total } from './styles'

export default function CustomerPendings() {
  const history = useHistory()
  const { id } = useParams()
  const [
    {
      customerName,
      paymentItems,
      orders,
      debts,
      totalToPay,
    },
    {
      getCustomerPendings,
      addPaymentItem,
      removePaymentItem,
    },
  ] = useCheckoutPayment()

  useEffect(() => {
    getCustomerPendings(id)
  }, [id, getCustomerPendings])

  const filterOrderItems = () => (
    paymentItems.filter((item) => item.type === 'order')
  )

  const filterDebtsItems = () => (
    paymentItems.filter((item) => item.type === 'customer_debt')
  )

  const onNext = () => {
    history.push(CHECKOUT_PAYMENT)
  }

  return (
    <InfoPage
      title="Pagamento"
      subtitle="Itens para pagamento"
      renderMenu={() => <SideMenu step={CHECKOUT_CUSTOMER_PENDINGS} />}
    >
      <Card>
        <div>
          <strong>
            { `Cliente: ${customerName}` }
          </strong>
        </div>

        <div>
          <Orders
            orders={orders}
            selectedOrders={filterOrderItems()}
            onSelect={(item) => addPaymentItem(item)}
            onDeselect={(item) => removePaymentItem(item)}
          />

          <Debts
            debts={debts}
            selectedDebts={filterDebtsItems()}
            onSelect={addPaymentItem}
            onDeselect={removePaymentItem}
          />
        </div>

        <Total>
          <span />
          <span />
          <span />
          <DescItemInfo label="R$ TOTAL">
            {currencyFormat(totalToPay)}
          </DescItemInfo>
        </Total>
      </Card>

      <Bottom>
        <Button onClick={onNext} color="primary">
          Formas de pagamento
          <ChevronRightIcon />
        </Button>
      </Bottom>
    </InfoPage>
  )
}
